import React from 'react';
import './UnderConstruction.css';

function UnderConstruction({ onBack }) {
  return (
    <div className="construction-container">
      <div className="construction-content">
        <div className="logo-section">
          <img src="https://vahaan-buy-and-sell-category-images.s3.ap-south-1.amazonaws.com/VahaanBazar_Image.png" alt="VahaanBazar" className="construction-logo" />
        </div>
        
        <div className="animation-section">
          <div className="building-animation">
            <div className="crane">🏗️</div>
            <div className="blocks">
              <div className="block block1">🧱</div>
              <div className="block block2">🧱</div>
              <div className="block block3">🧱</div>
              <div className="block block4">🧱</div>
            </div>
          </div>
        </div>
        
        <h1 className="construction-title">We're Building Something Amazing</h1>
        <p className="construction-subtitle">Our website is currently under construction. We're working hard to bring you an incredible experience!</p>
        
        <div className="progress-bar">
          <div className="progress-fill"></div>
        </div>
        
        <div className="features-preview">
          <div className="feature-item">
            <span className="feature-icon">🚗</span>
            <span>Vehicle Marketplace</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">💰</span>
            <span>Live Auctions</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🔧</span>
            <span>Service Support</span>
          </div>
        </div>
        
        <div className="contact-info">
          <p>Stay connected with us:</p>
          <div className="social-links">
            <a href="#" className="social-link">f</a>
            <a href="#" className="social-link">𝕏</a>
            <a href="#" className="social-link">📷</a>
            <a href="#" className="social-link">in</a>
          </div>
        </div>
        
        <button className="back-btn" onClick={onBack}>← Back to Website</button>
      </div>
    </div>
  );
}

export default UnderConstruction;